import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { id: "onboardingSlidesContainer" }
const _hoisted_3 = {
  key: 0,
  class: "locale-selector"
}
const _hoisted_4 = { class: "content-container" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "slide-card" }
const _hoisted_7 = { class: "slide-text" }
const _hoisted_8 = {
  key: 1,
  class: "title",
  id: "slide-title",
  "data-test": "title",
  tabindex: "-1"
}
const _hoisted_9 = { class: "main-text" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "slide-action" }

import {
  IonPage,
  IonContent,
  IonHeader,
  IonToolbar,
  IonSkeletonText,
} from "@ionic/vue";
import LocaleSelector from "@/components/Common/LocaleSelector/LocaleSelector.vue";
import AppButton from "@/components/Common/AppButton/AppButton.vue";
import ProgressEllipsis from "@/components/ProgressEllipsis/ProgressEllipsis.vue";
import { useLocaleStore, useOnboardingSlidesStore } from "@/store";
import { computed, nextTick, onBeforeMount, ref } from "vue";
import { OnboardingSlide } from "@/store/models/onboardingSlide.models";
import { SanityBlocks } from "sanity-blocks-vue-component";
import { useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingSlides',
  setup(__props) {

const localeStore = useLocaleStore();
const onboardingSlidesStore = useOnboardingSlidesStore();
const router = useRouter();

const slides = ref<Array<OnboardingSlide> | undefined | null>();
const activeSlideIndex = ref(0);

const slidesLength = computed(() => {
  return slides.value?.length ?? 0;
});

onBeforeMount(async () => {
  await onboardingSlidesStore.getOnboardingSlides();
  slides.value = onboardingSlidesStore.getIncompleteSlides;
  if (!slides.value || !(slides.value.length > 0)) {
    router.push({ name: "Home", replace: true });
  } else {
    await preloadImages(slides.value);
  }
});

const themeName = computed(() => {
  return localeStore.getCurrentLocaleTheme.toLowerCase();
});

const backgroundImageStyle = computed(() => {
  // TODO: this seems to be outdated. Update with all existing locales
  const hasImgAsset = ["global", "ca", "sg", "au", "nz"].includes(
    themeName.value
  );
  if (!hasImgAsset) {
    return {
      backgroundColor: "rgba(var(--ion-color-secondary-rgb), 0.2)",
    };
  }
  const img = require(`@/common/assets/welcome/feature-image/${themeName.value}.webp`);
  const backgroundImageStyle = { backgroundImage: `url(${img})` };
  return backgroundImageStyle;
});

const preloadImages = async (slides: Array<OnboardingSlide>) => {
  for (const slide of slides) {
    const image = new Image();
    image.src = slide.character;
  }
};

const nextSlide = () => {
  if (activeSlideIndex.value + 1 === slidesLength.value) {
    completeSlides();
    return;
  }
  activeSlideIndex.value += 1;
  focusOnTitle();
};

const previousSlide = () => {
  activeSlideIndex.value -= 1;
  focusOnTitle();
};

const focusOnTitle = async () => {
  await nextTick(() => {
    const titleEl = document?.querySelector("#slide-title") as HTMLElement;
    if (titleEl) {
      titleEl.focus();
    }
  });
};

const completeSlides = async () => {
  const slidesIds = slides.value?.map((slide) => slide._id);
  if (slidesIds) {
    await onboardingSlidesStore.updateOnboardingSlides(slidesIds);
  }
  router.push({ name: "Home", replace: true });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "feature-image",
          "data-test": "feature-image",
          style: _normalizeStyle(backgroundImageStyle.value)
        }, null, 4),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(IonHeader), { class: "ion-no-border" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonToolbar), null, {
                default: _withCtx(() => [
                  _createVNode(AppButton, {
                    size: "default",
                    class: "skip-button",
                    type: "textOnly",
                    label: _ctx.$t('onboardingSlides.skipBtn'),
                    ariaLabel: _ctx.$t('onboardingSlides.skipBtn'),
                    onClick: completeSlides,
                    "data-test": "skip-button"
                  }, null, 8, ["label", "ariaLabel"]),
                  (_unref(localeStore).getShowLocaleSwitcher)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(LocaleSelector, {
                          selectedLocaleCode: _unref(localeStore).currentLocale,
                          allowedLocaleCodes: _unref(localeStore).getAllowedLocaleCodes
                        }, null, 8, ["selectedLocaleCode", "allowedLocaleCodes"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonContent), { forceOverscroll: false }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: _normalizeClass(["character", { 'is-loading': _unref(onboardingSlidesStore).areSlidesLoading }])
                }, [
                  (!slides.value || _unref(onboardingSlidesStore).areSlidesLoading)
                    ? (_openBlock(), _createBlock(_unref(IonSkeletonText), {
                        key: 0,
                        animated: true,
                        style: {"width":"100%","height":"100%"}
                      }))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        "data-test": "character",
                        src: slides.value[activeSlideIndex.value]?.character,
                        alt: _ctx.$t('onboardingSlides.imageAlt')
                      }, null, 8, _hoisted_5))
                ], 2),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", null, [
                      (!slides.value || _unref(onboardingSlidesStore).areSlidesLoading)
                        ? (_openBlock(), _createBlock(_unref(IonSkeletonText), {
                            key: 0,
                            class: "title",
                            animated: true,
                            style: {"width":"40%","height":"24px","margin-bottom":"16px"}
                          }))
                        : (_openBlock(), _createElementBlock("h1", _hoisted_8, _toDisplayString(slides.value[activeSlideIndex.value]?.title), 1))
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      (!slides.value || _unref(onboardingSlidesStore).areSlidesLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item) => {
                              return _createVNode(_unref(IonSkeletonText), {
                                key: item,
                                animated: true,
                                style: {"width":"75%","height":"16px"}
                              })
                            }), 64))
                          ]))
                        : (_openBlock(), _createBlock(_unref(SanityBlocks), {
                            key: 1,
                            "data-test": "main-text",
                            blocks: slides.value[activeSlideIndex.value]?.main_text
                          }, null, 8, ["blocks"]))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    (
                    _unref(onboardingSlidesStore).areSlidesLoading || slidesLength.value > 1
                  )
                      ? (_openBlock(), _createBlock(ProgressEllipsis, {
                          key: 0,
                          isLoading: _unref(onboardingSlidesStore).areSlidesLoading,
                          quantity: slidesLength.value,
                          activeIndex: activeSlideIndex.value,
                          "aria-label": `${_ctx.$t(
                    'onboardingSlides.progressEllipsis.page'
                  )} ${activeSlideIndex.value + 1} ${_ctx.$t(
                    'onboardingSlides.progressEllipsis.of'
                  )} ${slidesLength.value}`,
                          class: "ellipsis",
                          "data-test": "progress-ellipsis"
                        }, null, 8, ["isLoading", "quantity", "activeIndex", "aria-label"]))
                      : _createCommentVNode("", true),
                    _createVNode(AppButton, {
                      size: "default",
                      width: "100%",
                      class: "next-button",
                      showLoadingSkeleton: _unref(onboardingSlidesStore).areSlidesLoading,
                      type: "primary",
                      label: 
                    activeSlideIndex.value + 1 === slidesLength.value
                      ? _ctx.$t('onboardingSlides.completeBtn')
                      : _ctx.$t('onboardingSlides.nextBtn')
                  ,
                      ariaLabel: 
                    activeSlideIndex.value + 1 === slidesLength.value
                      ? _ctx.$t('onboardingSlides.completeBtn')
                      : _ctx.$t('onboardingSlides.nextBtn')
                  ,
                      onClick: nextSlide,
                      "data-test": "next-button"
                    }, null, 8, ["showLoadingSkeleton", "label", "ariaLabel"]),
                    _createVNode(AppButton, {
                      style: _normalizeStyle({
                    visibility: activeSlideIndex.value > 0 ? 'visible' : 'hidden',
                  }),
                      size: "default",
                      class: "back-button",
                      type: "textOnly",
                      label: _ctx.$t('onboardingSlides.backBtn'),
                      ariaLabel: _ctx.$t('onboardingSlides.backBtn'),
                      onClick: previousSlide,
                      "data-test": "back-button"
                    }, null, 8, ["style", "label", "ariaLabel"])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})